import { useSelector } from "react-redux";

const useDashboardTiles = () => {
    const isEditing = useSelector((store) => store.general.isEditing);

    return { isEditing };
};

export default useDashboardTiles;
